import { useEffect, useState } from 'react'

import { ISelectOption } from '$/types'
import { useAppSelector } from 'app/hooks'
import { selectSystemScopeIdContainer } from 'app/layout/Navbar/Filters/globalFilterSelectors'
import {
  useLazyGetDataManagementDefaultDataViewTableRowsQuery,
  useGetDataManagementDefaultDataViewColumnDefinitionsQuery,
  ILineSegments
} from 'app/services/api/agGrid/agGrid'
import { useGetActiveSystemScopeFilterProfileQuery } from 'app/services/api/filterprofiles'

import DataLRSCharts from './DataLRSCharts'
import { IDataTableFilterModel } from '../Tables/DataTable'

interface ILRSWrapper {
  baselineId: string
  tableId: string | undefined
  appliedTableFilters?: IDataTableFilterModel
}

const LRSWrapper = ({ tableId, appliedTableFilters }: ILRSWrapper) => {
  const [selectedRoute, setSelectedRoute] = useState<ISelectOption | null>(null)
  const [lineData, setLineData] = useState<ILineSegments[]>([])
  const systemScopeIdContainer = useAppSelector(selectSystemScopeIdContainer)
  const [req] = useLazyGetDataManagementDefaultDataViewTableRowsQuery()

  const { currentData: defaultDataViewColDefs } =
    useGetDataManagementDefaultDataViewColumnDefinitionsQuery(
      {
        params: {
          viewId: tableId!,
          systemScopeId: systemScopeIdContainer.id!
        },
        cacheKeys: {
          systemScopeUpdatedAt: systemScopeIdContainer.updatedAt
        }
      },
      {
        skip: tableId == null || systemScopeIdContainer.id == null
      }
    )

  const { systemScopeFilterProfile } =
    useGetActiveSystemScopeFilterProfileQuery()

  useEffect(() => {
    setSelectedRoute(null)
  }, [systemScopeFilterProfile])

  useEffect(() => {
    let tempLineData: ILineSegments[] = []

    if (
      selectedRoute != null &&
      tableId != null &&
      systemScopeIdContainer.id != null
    ) {
      req(
        {
          params: {
            viewId: tableId
          },
          body: {
            systemScopeId: systemScopeIdContainer.id,
            startRow: 0,
            endRow: 1000,
            rowGroupCols: [],
            valueCols: [],
            pivotCols: [],
            pivotMode: false,
            groupKeys: [],
            filterModel: {
              ToDate: appliedTableFilters?.ToDate ?? null,
              FromDate: appliedTableFilters?.FromDate ?? null,
              RouteName: {
                values: [selectedRoute.value ?? ''],
                filterType: 'set'
              }
            },
            sortModel: [],
            sourceType: 'charts'
          },
          cacheKeys: {
            systemScopeUpdatedAt: systemScopeIdContainer.updatedAt
          }
        },
        false
      )
        .unwrap()
        .then((res) => {
          tempLineData = [...res.rows]
          setLineData(tempLineData)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }, [
    req,
    appliedTableFilters,
    tableId,
    selectedRoute,
    systemScopeIdContainer.id,
    systemScopeIdContainer.updatedAt
  ])

  const ContinuousRouteList: { label: string; value: string }[] = []

  systemScopeFilterProfile?.continuousRoutes.forEach((i) => {
    ContinuousRouteList.push({ label: i.name, value: i.name })
  })

  return (
    <DataLRSCharts
      filteredLineSegments={lineData ?? []}
      defaultDataViewColDefs={defaultDataViewColDefs ?? []}
      ContinuousRouteList={ContinuousRouteList}
      selectedRoute={selectedRoute}
      setSelectedRoute={setSelectedRoute}
    />
  )
}

export default LRSWrapper
